//Display Flat Progress for Programs
class UserAccountList extends React.Component {
    constructor(props) {
        super(props);
        this.fetchData = this.fetchData.bind(this);

        this.state = {
            loading: true,
            data: []
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData() {
        console.info("Getting accounts");
        let _self = this;
        this.setState({ loading: true });

        httpGet(buildRoute(mantlroutes.user_profile_accounts, { 'profileid': this.props.profileid })).then(
            function(value) {
                let response = JSON.parse(value);
                _self.setState({
                    loading: false,
                    data: response
                });
            })
        .catch(
            function(reason) {
                console.error('Error trying to load accounts list.', reason);
                alertify.error("Error trying to load accounts list.")
            });
    }

    render() {
        if(this.state.loading) {
            return (
                <LoadingSpinner />
            );
        }

        if(!this.state.loading && this.state.data.length == 0) {
            return (null);
        }

        const accounts = this.state.data.map((account,index) => <AccountInstitutionJumplink account={account} key={account.id} /> );
        return (
            <div>
                <h1 className="h2">My Accounts</h1>
                {accounts}
            </div>
        );

    }
}

function AccountInstitutionJumplink(props) {
    let parts = window.location.host.split('.');
    let spliceLength = 0;
    if(parts.length > 2){
       spliceLength = 1
    }
    //has subdomain
    if(props.account.federated_id > 0){
        parts.splice(0,spliceLength,props.account.institution.subdomain);
    }
    if(props.account.federated_id == 0){
        parts.splice(0,spliceLength,"my");
    }
    let newURL = window.location.protocol + '//' + parts.join('.');

    return (
        <p>
        <a href={newURL} className="">
           <img src={props.account.avatar} className="avatar" alt="Avatar" />
           {props.account.federated_id == 0 && (
                <React.Fragment><span className="flag flag--badged flag--secondary">my</span>.achievementstudio</React.Fragment>
            )}
            {props.account.federated_id > 0 && props.account.federated_id != null && (
                <React.Fragment>{props.account.institution.name}</React.Fragment>
            )}
           <span className="enspace"> </span><span className="flag flag--badged flag--faint">{props.account.username}</span>
        </a>
        </p>
    );

}

//Display Flat Progress for Programs
class UserProgramProgressList extends React.Component {
    constructor(props) {
        super(props);
        this.fetchData = this.fetchData.bind(this);

        this.state = {
            loading: true,
            data: []
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData() {
        let _self = this;
        this.setState({ loading: true });

        httpGet(buildRoute(mantlroutes.user_programs, { 'userid': this.props.userid })).then(
            function(value) {
                let response = JSON.parse(value);
                _self.setState({
                    loading: false,
                    data: response
                });
            })
        .catch(
            function(reason) {
                console.error('Error trying to load open programs.', reason);
                alertify.error("Error trying to load open programs.")
            });
    }

    render() {
        if(this.state.loading) {
            return (
                <LoadingSpinner />
            );
        }

        if(!this.state.loading && this.state.data.length == 0) {
            return (null);
        }

        // not loading and state data isn't empty, show programs
        const programs = this.state.data.map((programRole,index) => <ProgramProgressFlat program={programRole.program} organization={programRole.program.organization} key={programRole.id} /> );
        return (
            <div>
                <h1>My Programs</h1>
                {programs}
            </div>
        );

    }
}

class ProgramProgressFlat extends React.Component {
    constructor(props) {
        super(props);
        this.fetchData = this.fetchData.bind(this);

        this.state = {
            loading: true,
            //for now it will load an array of stages with chains
            //TODO replace with a new endpoint/serializer that gets a flat list with the progress properties
            data: []
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData() {
        let _self = this;
        this.setState({ loading: true });

        httpGet(buildRoute(mantlroutes.program_items, { 'orgid': this.props.organization.id, 'programid': this.props.program.id })).then(
            function(value) {
                let response = JSON.parse(value);
                _self.setState({
                    loading: false,
                    data: response
                });
            })
        .catch(
            function(reason) {
                console.error('Error trying to load open programs.', reason);
                alertify.error("Error trying to load open programs.")
            });
    }

    render() {
        if(this.state.loading) {
            return (
                <LoadingSpinner />
            );
        }

        if(!this.state.loading && this.state.data.length == 0) {
            return (null);
        }

        // not loading and state data isn't empty, show programs
        let nodes = [];
        //until we get a flat list, we have to dig through the various possibilities of node chains
        this.state.data.forEach(function(stage){
            stage.chains.forEach(function(chain){
                chain.nodes.forEach(function(node){
                    nodes.push(node);
                });
            });
        });

        //new array to add requisites.
        let nodes_with_req = [];

        nodes.forEach(function(el,index){
            if(el.prerequisite != null){
                nodes.forEach(function(node){
                    if(node.id == el.prerequisite){
                        el.prerequisite = node;
                        nodes_with_req.push(el);
                        return;
                    }
                });
            } else {
                nodes_with_req.push(el);
            }
        })

        const progressNodes = nodes_with_req.map((node,index) => <ProgramProgressNode node={node} key={node.id} program={this.props.program} handleRefresh={this.fetchData} /> );
        const programDesigner = buildView(mantlroutes.program_designer, { orgid: this.props.program.organization.id, programid: this.props.program.id })
        return (
            <div className="text--loosebottom">
                <h2 className="h3 normalweight"><a className="underline text--secondary" href={programDesigner}><b>{this.props.program.name}</b></a> by {this.props.organization.name}</h2>
                <div className="badge-progress badge-grid--grid">{progressNodes}</div>
            </div>
        );
    }
}



class ProgramProgressNode extends React.Component {
    constructor(props) {
        super(props);
        this.handleView = this.handleView.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            loading: true,
            allowed: false,
            reason: null,
            submissions_url: buildView(mantlroutes.program_submissions_view, { 'orgid': this.props.program.organization.id, 'programid': this.props.program.id })
        }
    }

    componentDidMount() {
        //note, can_submit only means they're a learner in program
        if(!this.props.node.earned && this.props.node.can_submit){
            this.fetchData();
        } else {
            this.setState({ loading: false });
        }
    }

    fetchData() {
        let _self = this;
        httpGet(buildRoute(mantlroutes.program_submission_allowed, { 'orgid': this.props.program.organization.id, 'programid': this.props.program.id, 'badgeid': this.props.node.item.id })).then(
            function(value) {
                let response = JSON.parse(value);
                _self.setState({
                    loading: false,
                    allowed: response.allowed,
                    reason: (response.reason != undefined) ? response.reason : null
                });
            })
        .catch(
            function(reason) {
                console.error('Error trying to check if submittable.', reason);
            });
    }

    handleView(event) {
        event.preventDefault();
        let _self = this;

        httpGet(this.props.node.item.view_url).then(
            function(value) {
                //TODO, use <Modal> component for these, get rid of jQuery
                let response = value;
                let $modal = buildModal(response,{
                    classes: 'modal modal--full',
                    header: "Preview Badge"
                });
                $('body').append($modal);
                $modal.on("modal:close",$modal,function(){
                    $modal.off("modal:close").remove();
                })
                $modal.openModal({ closeOnEsc: true });
            })
        .catch(
            function(reason) {
                console.error('Error trying to load badge view.', reason);
                alertify.error("Error trying to load badge view.")
            });
    }

    handleSubmit(event) {
        //load submit_url into modal
        let _self = this;
        httpGet(this.props.node.submit_url).then(
            function(value) {
                let response = value;
                let $modal = buildModal(response,{
                    classes: 'modal modal--full',
                    header: "Submit Evidence for Badge"
                });
                $('body').append($modal);
                $modal.on("modal:close",$modal,function(){
                    $modal.off("modal:close").remove();
                    //refresh nodes in this program
                    _self.props.handleRefresh();
                })
                $modal.openModal({ closeOnEsc: true });
            })
        .catch(
            function(reason) {
                console.error('Error trying to load badge submit.', reason);
                alertify.error("Error trying to load badge submit.")
            });
    }

    //<span className="badge-flag--earned" data-popover="tooltip" title="Badge Earned"><i className="icon-star"></i></span>
    render() {

        var figureClasses = "badge is-not-earned";
        if(this.props.node.earned || this.props.node.met_criteria.length > 0) {
            figureClasses = "badge is-earned";
        }

        return (
            <figure className={figureClasses}>
                <div className="badge-face badge-front">
                    {this.props.node.met_criteria.length > 0 && (
                        <span className="badge-flag--partial" title="Badge Partially Earned"><Icon classes="icon-star-half-empty" title="Badge Partially Earned" /></span>
                    )}

                    {this.props.node.prerequisite != null && this.props.node.can_submit && (
                        <ProgramProgressNodePrerequisite node={this.props.node.prerequisite} />
                    )}

                    <a href={this.props.node.item.view_url} className="" onClick={this.handleView}>
                        <img src={this.props.node.item.image} className="badge-art" alt={this.props.node.item.name} />
                    </a>
                    <figcaption className="badge-name">{this.props.node.item.name} {this.props.node.pending > 0 && (<a className="text--secondary" title="Pending Submissions" href={this.state.submissions_url}><Icon classes="icon-clock-o icon--larger icon--secondary" /> {this.props.node.pending}</a>)} </figcaption>
                    {this.state.loading && (<LoadingSpinner />)}
                    {!this.state.loading && !this.props.node.earned && this.props.node.can_submit && this.state.allowed && (
                        <button onClick={this.handleSubmit} className="button button--sm button--success">Submit Evidence</button>
                    )}
                    {!this.state.loading && !this.props.node.earned && this.props.node.can_submit && !this.state.allowed && (
                        <button className="button button--sm" disabled="disabled" title={this.state.reason}>Submit Evidence</button>
                    )}

                </div>
            </figure>
        );

    }
}


function ProgramProgressNodePrerequisite(props) {
    var flagClasses = "badge-flag--prerequisite is-not-earned";
    var imgClasses = "badge-disc border--muted";
    var title = "Unearned Prerequisite: " + props.node.item.name;
    if(props.node.earned) {
        flagClasses = "badge-flag--prerequisite is-earned";
        imgClasses = "badge-disc border--success";
        title = "Completed Prerequisite: " + props.node.item.name;
    } else if (props.node.pending > 0) {
        flagClasses = "badge-flag--prerequisite is-pending";
        imgClasses = "badge-disc border--secondary";
        title = "Completed Prerequisite: " + props.node.item.name;
    }
    return (
        <span className={flagClasses}>
            <img src={props.node.item.image} className={imgClasses} title={title} alt={title} />
        </span>
    );

}


// Open Orgs
class UserOpenOrganizations extends React.Component {
    constructor(props) {
        super(props);
        this.fetchData = this.fetchData.bind(this);

        this.state = {
            loading: true,
            data: []
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData() {
        let _self = this;
        this.setState({ loading: true });

        httpGet(buildRoute(mantlroutes.user_membership_open, { 'userid': this.props.userid })).then(
            function(value) {
                let response = JSON.parse(value);
                _self.setState({
                    loading: false,
                    data: response
                });
            })
        .catch(
            function(reason) {
                _self.setState({ loading: false });
                console.error('Error trying to load open programs.', reason);
                alertify.error("Error trying to load open programs.")
            });
    }

    render() {
        if(this.state.loading) {
            return (
                <LoadingSpinner />
            );
        }

        if(!this.state.loading && this.state.data.length == 0) {
            return (null);
        }

        // not loading and state data isn't empty
        const organizations = this.state.data.map((organization,index) => <OpenOrganization item={organization} userid={this.props.userid} key={organization.id} /> );
        return (
            <div>
                <h1 className="h3">Organizations I Can Join</h1>
                <ul className="collection">
                    {organizations}
                </ul>
            </div>
        );

    }
}

class OpenOrganization extends React.Component {
    constructor(props) {
        super(props);
        this.handleJoin = this.handleJoin.bind(this);
        this.handleViewLibrary = this.handleViewLibrary.bind(this);

        this.state = {
            data: [],
            loading: false
        };
    }

    componentDidMount() {
    }

    handleJoin() {
        alertLoading();
        let endpoint = buildRoute(mantlroutes.user_membership,{'userid': this.props.userid });
        httpPost(endpoint,{'organization': this.props.item.id}).then(
            function(value){
                let response = JSON.parse(value);
                removeLoading();
                alertify.closeLogOnClick(true).success('Joined Program');
                setTimeout(function(){ window.location.reload(); }, 500);
            })
        .catch(
            function(reason) {
                removeLoading();
                console.error(JSON.parse(reason));
                alertify.error('Unable to Join');
            });
    }
    //TODO add pagination or a new more complex component
    handleViewLibrary() {
        let _self = this;
        this.setState({ loading: true });
        alertLoading();
        let endpoint = buildRoute(mantlroutes.org_badges,{'orgid': this.props.item.id }) + formatParams({
            'page': 1,
            'page_size': 21

        });
        httpGet(endpoint).then(
            function(value){
                removeLoading();
                let response = JSON.parse(value);
                _self.setState({
                    data: response.results,
                    loading: false
                });
            })
        .catch(
            function(reason) {
                removeLoading();
                _self.setState({ loading: false });
                console.error(JSON.parse(reason));
                alertify.error('Unable to Open Library');
            });
    }

    render() {
        const badges = this.state.data.map((item,index) => <OrganizationLibraryPreviewItem badge={item} key={item.id} /> );
        return (
            <li className="collection-item">
                <h4 className="h5"><img onError={() => this.src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='} src={this.props.item.image} className="avatar" alt={this.props.item.name + "'s Logo"} /> {this.props.item.name}<span className="emspace"> </span><a className="text--sm" href={this.props.item.website}>{this.props.item.website}</a></h4>
                <blockquote>{this.props.item.description}</blockquote>
                <p><button className="button--secondary button--skinny" onClick={this.handleJoin}><Icon classes="icon-check" /> Join</button> <button className="button button--skinny" onClick={this.handleViewLibrary}>Preview Badges</button></p>
                {this.state.loading && (<LoadingSpinner />)}
                {badges}
            </li>
        )
    }
}

class OrganizationLibraryPreviewItem extends React.Component {
    constructor(props) {
        super(props);
        this.handleView = this.handleView.bind(this);
    }

    handleView(event) {
        event.preventDefault();
        console.table(this.props)
        httpGet(this.props.badge.view_url).then(
            function(value) {
                //TODO, figure out a way to use <Modal> component for these, get rid of jQuery
                let response = value;
                let $modal = buildModal(response,{
                    classes: 'modal modal--full',
                    header: "Preview Badge"
                });
                $('body').append($modal);
                $modal.on("modal:close",$modal,function(){
                    $modal.off("modal:close").remove();
                })
                $modal.openModal({ closeOnEsc: true });
            })
        .catch(
            function(reason) {
                console.error('Error trying to load program preview.', reason);
                alertify.error("Error trying to load program preview.")
            });
    }

    render() {
        return (
            <a href={this.props.badge.view_url} className="button--badge-disc" onClick={this.handleView}>
                <img src={this.props.badge.image} className="badge-disc badge-disc--large" alt={this.props.badge.name} />
            </a>
        );

    }
}



//Open Programs
class UserOpenPrograms extends React.Component {
    constructor(props) {
        super(props);
        this.fetchData = this.fetchData.bind(this);

        this.state = {
            loading: true,
            data: []
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData() {
        let _self = this;
        this.setState({ loading: true });

        httpGet(buildRoute(mantlroutes.user_programs_open, { 'userid': this.props.userid })).then(
            function(value) {
                let response = JSON.parse(value);
                _self.setState({
                    loading: false,
                    data: response
                });
            })
        .catch(
            function(reason) {
                console.error('Error trying to load open programs.', reason);
                alertify.error("Error trying to load open programs.")
            });
    }

    render() {
        if(this.state.loading) {
            return (
                <LoadingSpinner />
            );
        }

        if(!this.state.loading && this.state.data.length == 0) {
            return (null);
        }

        // not loading and state data isn't empty, show programs
        const programs = this.state.data.map((program,index) => <OpenProgram program={program} key={program.id} /> );
        return (
            <div>
                <h1 className="h3">Badge Programs I Can Join</h1>
                <ul className="collection">
                    {programs}
                </ul>
            </div>
        );

    }
}

class OpenProgram extends React.Component {
    constructor(props) {
        super(props);
        this.handleJoin = this.handleJoin.bind(this);
    }

    componentDidMount() {
    }

    handleJoin() {
        alertLoading();
        httpPost(this.props.program.join_url).then(
            function(value){
                response = JSON.parse(value);
                removeLoading();
                alertify.closeLogOnClick(true).success('Joined Program');
                setTimeout(function(){ window.location.reload(); }, 500);
            })
        .catch(
            function(reason) {
                removeLoading();
                console.error(JSON.parse(reason));
                alertify.error('Unable to Join');
            });
    }

    render() {
        return (
            <li className="collection-item">
                <h4 className="h5"><img src={this.props.program.organization.image} className="avatar" alt={this.props.program.organization.name + "'s Logo"} /> {this.props.program.organization.name}<span className="emspace"> </span><a className="text--sm" href={this.props.program.organization.website}>{this.props.program.organization.website}</a></h4>
                {/* <span className="float--right">Updated <FormattedDate date={this.props.program.modified} /></span> */}
                <p><span className="h2">{this.props.program.name}</span> <button className="button--secondary button--skinny float--right" onClick={this.handleJoin}><Icon classes="icon-check" /> Join</button></p>
                <ProgramPreview dataEndpoint={this.props.program.preview_url} />
            </li>
        )
    }
}


class ProgramPreview extends React.Component {
    constructor(props) {
        super(props);
        this.fetchData = this.fetchData.bind(this);

        this.state = {
            loading: true,
            data: []
        };
    }

    static propTypes = {
        itemView: PropTypes.bool
    }

    static defaultProps = {
        itemView: true
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData() {
        let _self = this;
        this.setState({ loading: true });

        httpGet(this.props.dataEndpoint).then(
            function(value) {
                let response = JSON.parse(value);
                _self.setState({
                    loading: false,
                    data: response
                });
            })
        .catch(
            function(reason) {
                console.error('Error trying to load program preview.', reason);
                alertify.error("Error trying to load program preview.")
            });
    }

    render() {
        if(this.state.loading) {
            return (
                <LoadingSpinner />
            );
        }

        if(!this.state.loading && this.state.data.length == 0) {
            return (
                <div className="alert text--lg">
                    This program contains no badges.
                </div>
            );
        }

        // not loading and state data isn't empty
        const items = this.state.data.map((item,index) => <ProgramPreviewItem stageItem={item} key={item.id} itemView={this.props.itemView} /> );

        return (
            <div>
                {items}
            </div>
        );
    }
}

class ProgramPreviewItem extends React.Component {
    constructor(props) {
        super(props);
        this.handleView = this.handleView.bind(this);

    }

    static propTypes = {
        itemView: PropTypes.bool
    }

    static defaultProps = {
        itemView: true
    }

    handleView(event) {
        event.preventDefault();
        let _self = this;

        let endpoint = this.props.stageItem.item.view_url;
        if(!this.props.itemView) {
            endpoint = this.props.stageItem.url;
        }

        httpGet(endpoint).then(
            function(value) {
                //TODO, figure out a way to use <Modal> component for these, get rid of jQuery
                let response = value;
                let $modal = buildModal(response,{
                    classes: 'modal modal--full',
                    header: "Preview Badge"
                });
                $('body').append($modal);
                $modal.on("modal:close",$modal,function(){
                    $modal.off("modal:close").remove();
                })
                $modal.openModal({ closeOnEsc: true });
            })
        .catch(
            function(reason) {
                console.error('Error trying to load program preview.', reason);
                alertify.error("Error trying to load program preview.")
            });
    }

    render() {
        let endpoint = this.props.stageItem.item.view_url;
        if(!this.props.itemView) {
            endpoint = this.props.stageItem.url;
        }
        return (
            <a href={endpoint} className="button--badge-disc" onClick={this.handleView}>
                <img src={this.props.stageItem.item.image} className="badge-disc badge-disc--large" alt={this.props.stageItem.item.name} />
            </a>
        );

    }
}


function BadgeSkills(props) {
    const skills = props.skills.map((skill,index) => <BadgeSkillsFlag skill={skill} key={index} /> );
    if (skills.length > 0){
        return (
            <div>
                <img src={mantl.static_url + "assets/images/icon-skills.svg" } className="icon--svg" alt="Skills Icon" /> {skills}
            </div>
        );
    } else {
        return (
            <div>
                <img src={mantl.static_url + "assets/images/icon-skills.svg" } className="icon--svg" alt="Skills Icon" /> <span class="flag flag--faint flag--badged">None</span>
            </div>
        );
    }

}

function BadgeSkillsFlag(props) {
    return (
        <span className="flag flag--badged">{props.skill}</span>
    );
}


//Badge Programs
class BadgeRelatedPrograms extends React.Component {
    constructor(props) {
        super(props);
        this.fetchData = this.fetchData.bind(this);

        this.state = {
            loading: true,
            data: []
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData() {
        let _self = this;
        this.setState({ loading: true });
        httpGet(buildRoute(mantlroutes.badge_programs, { 'badgeid': this.props.badgeid })).then(
            function(value) {
                let response = JSON.parse(value);
                _self.setState({
                    loading: false,
                    data: response
                });
            })
        .catch(
            function(reason) {
                console.error('Error trying to load programs.', reason);
                alertify.error("Error trying to load programs.")
            });
    }

    render() {
        if(this.state.loading) {
            return (
                <LoadingSpinner />
            );
        }

        if(!this.state.loading && this.state.data.length == 0) {
            return (
                <div className="alert">No programs offer this badge.</div>
            );
        }

        // not loading and state data isn't empty, show programs
        const programs = this.state.data.map((program,index) => <BadgeRelatedProgram program={program} key={program.id} /> );
        return (
            <ul className="collection">
                {programs}
            </ul>
        );

    }
}

class BadgeRelatedProgram extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }


    render() {
        return (
            <li className="collection-item">
                <p><span className="h2">{this.props.program.name}</span></p>
                <ProgramPreview dataEndpoint={this.props.program.preview_url} itemView={false} />
            </li>
        )
    }
}

